// extracted by mini-css-extract-plugin
export default {"productPreview":"ProductPreview_productPreview__S72Z2","mobile":"ProductPreview_mobile__qj0ZP"};